import type { ComponentPropsWithRef } from "react";
import { SanitizedContent } from "@/common/components-2/sanitized-content";
import { cn } from "@/services/styles/cn";

export function CmsIconItem({
  icon,
  title,
  description,
  className,
  ...props
}: ComponentPropsWithRef<"li"> & {
  icon: string;
  title: string;
  description: string;
}) {
  return (
    <li className={cn("flex flex-col max-lg:items-center max-lg:text-center", className)} {...props}>
      <SanitizedContent as="div" content={icon} className="[&>svg]:min-h-[60px] [&>svg]:min-w-[60px]" />
      <strong className="mt-6 text-lg">{title}</strong>
      <SanitizedContent as="div" content={description} className="mt-3" />
    </li>
  );
}
